function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9153 17.395L22.5981 1.07791C21.903 0.382738 20.9813 0 19.9971 0C19.0129 0 18.0912 0.382738 17.396 1.07791L1.0867 17.3872C1.07889 17.395 1.07889 17.395 1.07108 17.4029C-0.358326 18.8401 -0.358326 21.1677 1.07889 22.605C1.73501 23.2611 2.59422 23.636 3.52373 23.6751C3.56278 23.6751 3.60184 23.6829 3.64089 23.6829H4.2892V35.6883C4.2892 38.0629 6.21851 40 8.60086 40H14.9824C15.6307 40 16.1541 39.4767 16.1541 38.8284V29.4083C16.1541 28.3226 17.0367 27.44 18.1224 27.44H21.8873C22.9731 27.44 23.8557 28.3226 23.8557 29.4083V38.8205C23.8557 39.4689 24.379 39.9922 25.0273 39.9922H31.4011C33.7756 39.9922 35.7128 38.0629 35.7128 35.6805V23.6751H36.3142C37.2984 23.6751 38.2201 23.2923 38.9153 22.5971C40.3447 21.1677 40.3447 18.8323 38.9153 17.395Z",
  fill: "#EF8334"
});

var SvgHomepage = function SvgHomepage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomepage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homepage.45c643a5.svg";
export { ForwardRef as ReactComponent };